<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Reserve Category
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="headers"
          :items="reserveList"
          v-bind:search="search"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.label }}</td>
              <td align="center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignReserve(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      labels: {
        reserve: 'Reserve Category'
      },
      filters: {
        reserve: undefined
      },
      headers: [{ text: 'Reserve Category', align: 'left', value: 'label' }, TableConst.tableActionHeader],
      reserveList: [],
      loading: false
    }
  },
  mounted() {
    this.doFetch()
  },
  methods: {
    async doFetch() {
      this.loading = true
      this.reserveList = []
      try {
        const apiUrl = this.$store.state.commons.menu.reserveList
        if (apiUrl) {
          const expand = {
            busCls: this.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result && result.data && result.data.data) {
            this.reserveList = result.data.data
          }
        }
      } catch (e) {}
      this.loading = false
    },
    closeDialog() {
      this.filters.reserve = ''
      this.$emit('close')
    },
    assignReserve(data) {
      this.$emit('assign-reserve', data.label)
      this.$emit('assign-reserve-info', data)
      this.$emit('close')
    }
  },
  props: {
    busCls: {
      type: String,
      default: ''
    }
  },
  computed: {},
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
